// App.jsx (Bootstrap 5 – FULL HEIGHT SIDEBAR + TOPBAR | LIGHT THEME | SMOOTH COLLAPSE)
import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  NavLink,
  Link,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./App.css";

import LoginUser from "./loginUser/LoginUser";
import Dashboard from "./Dashboard/Dashboard";
import User from "./getUser/User";
import { AddUser } from "./Adduser/AddUser";
import Upate from "./updateUser/Upate";
import MonthlyMIS from "./monthlyMIS/monthlyMISRepot";
import RecruiterPerformance from "./RecruiterPerformanceRpt/recruiterPerformanceReport";
import DomainRpt from "./DomainRpt/DomainWiseRpt";
import ResetPassword from "./ResetPassword/ResetPassword";
import Notification from "./Notification/Notification";

/* ===================== LAYOUT ===================== */
const Layout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  
  const userType = localStorage.getItem("userType") || "admin";
  const username = localStorage.getItem("username") || "Admin User";
  const initial = username.charAt(0).toUpperCase();

  return (
    <div className="app-root">
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />

      <div className="right-area">
        {/* TOPBAR */}
        <div className="topbar">
          <div className="topbar-left">
            <span className="fw-bold text-secondary">RESOURCE MANAGEMENT</span>
          </div>

          <div className="topbar-right">
            <Link to="/notification" className="avatar-btn">
              <i className=" bi bi-bell bell-icon" title="Notification"></i>
            </Link>
            <div className="dropdown">
              <button
                className="avatar-btn dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
              >
                <span className="avatar-circle" title="Profile">
                  {initial}
                </span>
              </button>

              <ul className="dropdown-menu dropdown-menu-end avatar-dropdown">
                <li className="dropdown-header text-center pb-2">
                  <div className="avatar-lg mx-auto mb-2">{initial}</div>
                  <div className="fw-bold text-dark text-capitalize">{username}</div>
                  <div className="text-muted small text-capitalize">{userType}</div>
                </li>

                <li>
                  <hr className="dropdown-divider my-2" />
                </li>

                <li>
                  <Link to="/ResetPassword" className="dropdown-item">
                    <div className="dropdown-item-icon">
                      <i className="bi bi-key-fill"></i>
                    </div>
                    Reset Password
                  </Link>
                </li>

                <li>
                  <button
                    className="dropdown-item text-danger"
                    onClick={() => navigate("/")}
                  >
                    <div className="dropdown-item-icon bg-danger-light">
                      <i className="bi bi-box-arrow-right"></i>
                    </div>
                    Logout
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* PAGE CONTENT */}
        <div className="page-wrapper">
          <Outlet />
        </div>

        {/* FOOTER */}
        <footer className="app-footer">
          All rights reserved ©{" "}
          <a
            href="https://transtrack.co.in"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary text-decoration-none"
          >
            Transtrack &nbsp;
          </a>{" "}
          2025
        </footer>
      </div>
    </div>
  );
};

/* ===================== SIDEBAR ===================== */
const Sidebar = ({ collapsed, setCollapsed }) => {
  const location = useLocation();

  const navClass = ({ isActive }) =>
    `nav-link sidebar-link ${isActive ? "active-link" : "inactive-link"}`;

  // auto-open Reports if any child active
  const reportsActive =
    location.pathname.includes("monthlyMIS") ||
    location.pathname.includes("recruiterPerformance") ||
    location.pathname.includes("domainRpt");

  const [reportsOpen, setReportsOpen] = useState(reportsActive);

  return (
    <aside className={`sidebar-fixed ${collapsed ? "collapsed" : ""}`}>
      {/* LOGO */}
      <div className="sidebar-header">
        {/* <img
          src={
            collapsed
              ? "https://tse4.mm.bing.net/th/id/OIP.Pe9wI47eHvv3xeSIsrPX9AHaHa"
              : "https://transtrack.co.in/assets/images/logo/logo-dark.png"
          }
          alt="logo"
          className="sidebar-logo"
        /> */}
        <img
          src="/Transtrack_Logo_HD__NEW.webp"
          alt="logo"
          className="sidebar-logo"
        />
        <button
          className="collapse-btn"
          onClick={() => setCollapsed(!collapsed)}
        >
          <i
            className={`bi ${
              collapsed ? "bi-chevron-right" : "bi-chevron-left"
            }`}
          />
        </button>
      </div>

      {/* NAVIGATION */}
      <nav className="nav flex-column sidebar-nav">
        <NavLink to="/dashboard" className={navClass}>
          <i className="bi bi-speedometer2" />
          {!collapsed && <span>Dashboard</span>}
        </NavLink>

        <NavLink to="/user" className={navClass}>
          <i className="bi bi-people" />
          {!collapsed && <span>Manage Records</span>}
        </NavLink>

        <NavLink to="/add" className={navClass}>
          <i className="bi bi-person-plus" />
          {!collapsed && <span>Add Record</span>}
        </NavLink>

        {/* ========== REPORTS PARENT ========== */}
        {/* ========== REPORTS PARENT ========== */}
        <div
          className={`nav-link sidebar-link sidebar-parent ${
            reportsOpen ? "active-link" : ""
          }`}
          onClick={() => setReportsOpen(!reportsOpen)}
        >
          <i className="bi bi-bar-chart-line" />
          {!collapsed && <span>Reports</span>}
          {!collapsed && (
            <i
              className={`bi bi-chevron-${
                reportsOpen ? "down" : "right"
              } ms-auto`}
            />
          )}
        </div>

        {/* REPORTS SUBMENU */}
        {reportsOpen && (
          <div className="sidebar-submenu">
            <NavLink to="/monthlyMIS" className={navClass}>
              <i className="bi bi-dot" />
              {!collapsed && <span>Monthly MIS</span>}
            </NavLink>

            <NavLink to="/recruiterPerformance" className={navClass}>
              <i className="bi bi-dot" />
              {!collapsed && <span>Recruiter Monthly Report</span>}
            </NavLink>

            <NavLink to="/domainRpt" className={navClass}>
              <i className="bi bi-dot" />
              {!collapsed && <span>Domain Report</span>}
            </NavLink>
          </div>
        )}
      </nav>
    </aside>
  );
};

/* ===================== ROUTER ===================== */
const router = createBrowserRouter([
  { path: "/", element: <LoginUser /> },
  { path: "/ResetPassword", element: <ResetPassword /> },
  {
    path: "/",
    element: <Layout />,
    children: [
      { path: "dashboard", element: <Dashboard /> },
      { path: "user", element: <User /> },
      { path: "add", element: <AddUser /> },
      { path: "update/:id", element: <Upate /> },
      { path: "monthlyMIS", element: <MonthlyMIS /> },
      { path: "recruiterPerformance", element: <RecruiterPerformance /> },
      { path: "domainRpt", element: <DomainRpt /> },
      { path: "notification", element: <Notification /> },
    ],
  },
]);

export default function App() {
  return <RouterProvider router={router} />;
}
